import { render } from "./ContratosIndex.vue?vue&type=template&id=7a958e00"
import script from "./ContratosIndex.vue?vue&type=script&lang=js"
export * from "./ContratosIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/cruds/ContratosIndex.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7a958e00"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7a958e00', __exports__)) {
    api.reload('7a958e00', __exports__)
  }
  
  module.hot.accept("./ContratosIndex.vue?vue&type=template&id=7a958e00", () => {
    api.rerender('7a958e00', render)
  })

}


export default __exports__